<template>
	<div v-if="show" :class="{ 'loading' : !is_loaded}" class="loadable">
		<!--<button class="button" @click="refresh">refresh</button>-->
		<label class="text-uppercase">% of employees registered to the app</label>
		<GChart
			type="PieChart"
			:data="chartData"
			:options="chartOptions"
			:events="chartEvents"
			ref="chart"
			@ready="onChartReady"
		/>
	</div>

</template>

<script>
	export default{
		props : {
			course : {
				required : false
			}
		},
		data : function(){
			return {
				show : false,
				chartData : [],
				chartOptions : {
					colors: ['#11a5a7','#db504a'],
					height: 250,
					chartArea:{width:'100%'},
					tooltip : { trigger : 'selection' },
					sliceVisibilityThreshold : 0
				},
				chartEvents : {},
				chart :null,
				is3D: true,
				colors : null,
				is_loaded : false
			}
		},

		created : function(){

			this.colors = this.config.COLORS;

			this.chartOptions.colors = [
				this.colors.GREEN,
				this.colors.RED
			];
			var vue_instance = this;

			this.chartEvents = {
				select : () => {
					var selection = this.chart.getSelection();

					var row, column = null;

					if(selection.length == 0){
						vue_instance.emitSelection('none', {
							row : null, 
							column : null
						});
					}else{
						vue_instance.emitSelection('filter-sign-ups', {
							row : selection[0].row+1,
							column : selection[0].column
						});
					}
				}
			}

			this.iniChart();
		},
		methods : {
			iniChart : function(){
				var params = {
					filters : {
						page_loading : false
					}
				}

				if(this.course)
					params.filters.course_id = this.course;

				this.$store.dispatch('getSignUps', params).then((res) => {

					this.chartData = [
						['Status', 'Amount'],
						['Registered', res.data.data.total_actives],
						['Not registered', res.data.data.total_no_actives]
					];

					this.show = true;
				}).catch((error) => {
					console.log(error);
				});
			},
			refresh : function(){
				this.iniChart();
			},
			onChartReady : function(chart, google){
				this.chart = chart;
				this.is_loaded = true;
			},
			emitSelection : function(type, data){
				this.$emit('filter', {
					type : type,
					row : data.row,
					column : data.column
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/charts/SignUpsPieChartComponent.vue